import useMessageInbox from "./useMessageInbox";
export default function useUnreadMessages() {
  const { list } = useMessageInbox();
  return list
    .filter((row) => !row.isSelf && !row.blocked)
    .reduce((sum, row) => sum + (row.unread || 0), 0);
}
